import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './components/App';
import '../src/css/animateSlider/jquery.animateSlider.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../src/css/App.css';
import './vendor/jssor/jssor.slider.min.js';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js